import { FC } from "react";

import IAQTabTemplate from "../Template";

type FieldErrors = { co2?: string; hcho?: string; tvoc?: string; pm25?: string; pm10?: string };

type PropTypes = {
  co2: number;
  hcho: number;
  tvoc: number;
  pm25: number;
  pm10: number;
  errors?: FieldErrors;
  handleFieldChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const LongTermLimit: FC<PropTypes> = ({ co2, hcho, tvoc, pm25, pm10, errors, handleFieldChange }) => {
  return (
    <IAQTabTemplate
      infoDescription="Long-term Exposure Limit (LT) - Primary compliance benchmark: Maximum acceptable rolling average over a long window. Alert triggers when the rolling average over the specified period exceeds this value. Averaging period is fixed per DM-HSD-GU119.
This is the primary criterion used by Dubai Municipality for compliance assessment."
      handleFieldChange={handleFieldChange}
      gasFields={[
        {
          label: "CO₂",
          unit: "ppm",
          hint: "Def: 800 ppm / 8-h rolling avg",
          value: co2,
          name: "longTermLimit.co2",
          error: errors?.co2,
        },
        {
          label: "HCHO",
          unit: "ppm",
          hint: "Def: 0.01 ppm / 8-h rolling avg",
          value: hcho,
          name: "longTermLimit.hcho",
          error: errors?.hcho,
        },
        {
          label: "TVOC",
          unit: "mg/m³",
          hint: "Def: 0.6 mg/m³ / 8-h rolling avg",
          value: tvoc,
          name: "longTermLimit.tvoc",
          error: errors?.tvoc,
        },
      ]}
      pmFields={[
        {
          label: "PM2.5",
          unit: "µg/m³",
          hint: "Def: 35 µg/m³ / 24-h rolling avg",
          value: pm25,
          name: "longTermLimit.pm25",
          error: errors?.pm25,
        },
        {
          label: "PM10",
          unit: "µg/m³",
          hint: "Def: 150 µg/m³ / 24-h rolling avg",
          value: pm10,
          name: "longTermLimit.pm10",
          error: errors?.pm10,
        },
      ]}
    />
  );
};

export default LongTermLimit;
